<!-- Page content -->
<div class="page-content">
    <!-- Main content -->
    <div class="content-wrapper">
        <app-layout-partial-header></app-layout-partial-header>
        <!-- Inner content -->
        <div class="content-inner">
            <router-outlet></router-outlet>
        </div>
        <!-- / Inner content -->
    </div>
    <!-- / Main content -->
</div>
<!-- / Page content -->
